<script setup lang="ts">
import { NTag } from "naive-ui";
import type { OpenItemComment as OIComment, OpenItemChangelog } from "../../models/contador";
import { formatJSDate } from "../../utils/dates";
import OpenItemComment from "./OpenItemComment.vue";
import OpenItemDetailChange from "./OpenItemDetailChange.vue";

defineProps<{
    history: {
        date: number;
        items: (OIComment | OpenItemChangelog)[];
    }[];
    propertyOptions: Array<{ label: string; value: string }>;
}>();

const emit = defineEmits<{
    "comment-edited": [];
}>();

function getItemType(item: OIComment | OpenItemChangelog): "comment" | "change" {
    if ("content" in item) {
        return "comment";
    } else {
        return "change";
    }
}
</script>

<template>
    <div class="h-full space-y-6">
        <div v-for="x in history" :key="x.date" class="space-y-4">
            <!-- Date Header -->
            <div class="flex justify-center mb-6 capitalize">
                <n-tag type="primary" size="small" :bordered="false" :round="true">
                    {{ formatJSDate(new Date(x.date)).RELATIVE_DATE_FORMAT }}
                </n-tag>
            </div>

            <!-- Events for this date -->
            <div class="space-y-8">
                <div v-for="item in x.items" :key="item.id">
                    <!-- Comment Event -->
                    <open-item-comment
                        v-if="getItemType(item) === 'comment'"
                        :comment="item as OIComment"
                        :show-resolved-tag="(item as OIComment)?._resolved_comment"
                        @comment-edited="emit('comment-edited')"
                    />

                    <!-- Change Event -->
                    <open-item-detail-change
                        v-else-if="getItemType(item) === 'change'"
                        :property-options="propertyOptions"
                        :change="item as OpenItemChangelog"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
